<template>
  <div id="scrollableContent" :style="myBlockProps.getStyles(visible)" @scrollend=handleScroll ref="scrollWindow">
    <dynamic-block v-for="child in children" :key="child.properties.guid" :block="child"/>
  </div>
</template>

<script>
import ContentBlock from '../ContentBlock.vue';
import DynamicBlock from '../DynamicBlock.vue';

export default {
  name: 'scrollable-content-block',
  components: { DynamicBlock },
  extends: ContentBlock,
  data() {
    return {
      scrollWindow: null,
    };
  },
  methods: {
    handleScroll() {
      const sections = document.querySelectorAll('div .scroll-text-section');
      sections.forEach((section) => {
        const sectionRect = section.getBoundingClientRect();
        const refRect = this.$refs.scrollWindow.getBoundingClientRect();
        if (sectionRect.top - 1 <= refRect.top) {
          const sectionGuid = section.getAttribute('id');
          if (this.listOfSectionGuidByClauseGuid[this.identification].includes(sectionGuid) && !this.checkSameSectionGuid(sectionGuid)) {
            this.$store.dispatch('setScrollBrowserSelected', {
              clauseGuid: this.identification,
              sectionGuid
            });
          }
        }
      });
    },
    checkSameSectionGuid(sectionGuid) {
      return this.scrollBrowserSelected === sectionGuid;
    }
  },
  computed: {
    listOfSectionGuidByClauseGuid() {
      return this.$store.getters.getClauseGuidWithSectionsGuid;
    },
    scrollBrowserSelected() {
      return this.$store.getters.getSrollBrowserSelected(this.identification);
    }
  }
};
</script>
<style>
#scrollableContent {
  scroll-behavior: smooth;
}
#scrollableContent > div {
  background-repeat: repeat;
}
</style>
